import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative" }

import { NodeViewWrapper } from '@tiptap/vue-3';
import { computed, onMounted, provide, ref, nextTick } from 'vue';
import { useStore } from 'vuex';
import BoardView from '../../pages/BoardView.vue';
import HeaderCustom from '../../widgets/HeaderCustom.vue';
import { ResourceType } from '@/types/resources';
import { Node } from '@tiptap/pm/model';
import EventBus from '@/utilities/eventBus';
import ItemNotFound from '@/components/widgets/ItemNotFound';
import constants from '@/utilities/constants';


const __default__ = {
  name: 'BoardEmbed',
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    node: {},
    updateAttributes: {},
    deleteNode: {},
    getPos: {},
    editor: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const flatBoards = computed(() => store.getters.getFlatBoards);

const currentBoard = computed(() => flatBoards.value[props.node.attrs['board-id']] || {});
const localBoardLayout = ref(currentBoard.value?.layout);
const localGroupBy = ref('status');
const localSortBy = ref('manual');
const hideEmptyGroups = ref(false);

const currentLayout = computed(() => {
  return localBoardLayout.value || currentBoard.value?.layout;
});

onMounted(() => {
  // Update layout if it's updated on the board itself
  if ((currentBoard as any).value.layout !== props.node.attrs.layout && props.editor.id) {
    nextTick(() => {
      props?.updateAttributes?.({ layout: (currentBoard as any).value.layout });
    });
  }
});

const updateAttribute = (attr: any) => {
  const [key] = Object.keys(attr);
  switch (key) {
    case 'layout':
      localBoardLayout.value = attr[key];
      return;
    case 'group-by':
      localGroupBy.value = attr[key];
      return;
    case 'sort-by':
      localSortBy.value = attr[key];
      return;
    case 'hide-empty-groups':
      hideEmptyGroups.value = attr[key];
      return;
    case 'full-width':
      // used to force small screen view for table of content
      EventBus.$emit('updateFullWidth', {
        editorId: props.editor.id,
        value: attr[key],
        boardId: props.node.attrs['board-id'],
      });
  }
  props.updateAttributes(attr);
};

provide(
  'embeddedBoardAttributes',
  computed(() => ({
    boardId: props.node.attrs['board-id'],
    layout: currentLayout.value,
    fullWidth: props.node.attrs['full-width'],
    readOnly: props.node.attrs['read-only'],
    groupBy: localGroupBy.value,
    sortBy: localSortBy.value,
    getPos: props.getPos,
    editor: props.editor,
    hideEmptyGroups: hideEmptyGroups.value,
    deleteNode: props.deleteNode,
  }))
);
provide('embed', true);

const showItemNotFound = computed(() => {
  const boardId = props.node.attrs['board-id'];
  return flatBoards.value[`${boardId}_notFound`];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NodeViewWrapper), {
    class: _normalizeClass(["embedded-board show-selection ignore-editor-line-height max-w-full border border-solid border-important-border rounded-lg my-2", { 'w-full': _ctx.node.attrs[_unref(constants).fullWidth] }])
  }, {
    default: _withCtx(() => [
      _createVNode(HeaderCustom, {
        class: "rounded-t-lg",
        "resource-id": _ctx.node.attrs['board-id'],
        "current-layout": _ctx.node.attrs.layout,
        "resource-type": _unref(ResourceType).Board,
        onUpdateAttribute: updateAttribute
      }, null, 8, ["resource-id", "current-layout", "resource-type"]),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("div", _hoisted_1, [
        (showItemNotFound.value)
          ? (_openBlock(), _createBlock(_unref(ItemNotFound), {
              key: 0,
              class: "border rounded-lg"
            }))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createVNode(BoardView, _mergeProps(_ctx.node.attrs, {
          class: "rounded-lg",
          "editor-id": _ctx.editor.id,
          "board-id": _ctx.node.attrs['board-id'],
          "cards-layout": currentLayout.value
        }), null, 16, ["editor-id", "board-id", "cards-layout"])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})